// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";
import { DragIndicator } from "@mui/icons-material";
import { Box, Button, Grid, DragDrop } from "@/components/core";
import { useShortcutMenuStore } from "@/store/shortcut-menu";

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  background: isDragging ? "lightgrey" : "inherit",
  borderRadius: 5,
  marginLeft: 10,
  flex: "1 1 0px",
  ...draggableStyle,
});

export function ShortcutItem({ index, shortcut }: any) {
  const { isEditing } = useShortcutMenuStore();

  function ShortcutItemComponent() {
    return (
      <Box>
        <Grid wrap="nowrap" justifyContent="flex-start">
          {isEditing && (
            <Grid.Item>
              <DragIndicator />
            </Grid.Item>
          )}
          <Grid.Item>
            <Button
              startIcon={shortcut.icon}
              variant="text"
              disabled={isEditing}
              sx={{ whiteSpace: "nowrap" }}
            >
              {shortcut.name}
            </Button>
          </Grid.Item>
        </Grid>
      </Box>
    );
  }

  if (isEditing) {
    return (
      <DragDrop.Draggable draggableId={shortcut.id} index={index}>
        {(provided: any, snapshot: any) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
          >
            <ShortcutItemComponent />
          </div>
        )}
      </DragDrop.Draggable>
    );
  }

  return <ShortcutItemComponent />;
}

ShortcutItem.propTypes = {
  index: PropTypes.number.isRequired,
  shortcut: PropTypes.object,
};
